module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "row py-5"
  }, [_c('div', {
    staticClass: "col-sm-2 pointer",
    on: {
      "click": _vm.openAvatarUpload
    }
  }, [(_vm.company.imageLogo) ? _c('img', {
    staticClass: "avatarImage",
    attrs: {
      "src": _vm.company.imageLogo
    }
  }) : _c('img', {
    staticClass: "avatarImage",
    attrs: {
      "src": "/static/images/auth/supplier.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    ref: "a",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.receiveImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6 mb-2",
    class: {
      error: _vm.$v.company.brand.$invalid
    }
  }, [_c('div', [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Brand Name\n                        "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                            *\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.brand),
      expression: "company.brand"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.brand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "brand", $event.target.value)
      }, _vm.$v.company.brand.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.brand.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.brand.required) ? _c('span', [_vm._v("Brand Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.brand.minLength) ? _c('span', [_vm._v("Must have at least 4 characters")]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2 text-right"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": _vm.$v.company.$invalid
    },
    on: {
      "click": _vm.save
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('div', {
    staticClass: " border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Company Details\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 mb-2",
    class: {
      error: _vm.$v.company.companyName.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Company Name\n                                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                        *\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.companyName),
      expression: "company.companyName"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.companyName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "companyName", $event.target.value)
      }, _vm.$v.company.companyName.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.companyName.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.companyName.required) ? _c('span', [_vm._v("Company Name is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Website\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.website),
      expression: "company.website"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "website", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0",
    class: {
      error: _vm.$v.company.companyAddress.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Company Address\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                    *\n                                ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.companyAddress),
      expression: "company.companyAddress"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.company.companyAddress)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "companyAddress", $event.target.value)
      }, _vm.$v.company.companyAddress.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.companyAddress.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.companyAddress.required) ? _c('span', [_vm._v("Company Address is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2",
    class: {
      error: _vm.$v.company.postalCode.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    ZIP-Code\n                                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                        *\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.postalCode),
      expression: "company.postalCode"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.postalCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "postalCode", $event.target.value)
      }, _vm.$v.company.postalCode.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.postalCode.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.postalCode.required) ? _c('span', [_vm._v("ZIP-Code is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2",
    class: {
      error: _vm.$v.company.location.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Location\n                                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                        *\n                                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.location),
      expression: "company.location"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.location)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "location", $event.target.value)
      }, _vm.$v.company.location.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.location.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.location.required) ? _c('span', [_vm._v("Location is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('vSelect', {
    attrs: {
      "options": _vm.countriesStored,
      "on-change": _vm.setCountryId
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }), _vm._v(" "), (_vm.$v.company.country.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [(!_vm.$v.company.country.required) ? _c('span', [_vm._v("Country is required.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    License Number\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.licenseNumber),
      expression: "company.licenseNumber"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "licenseNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    CAE\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.cae),
      expression: "company.cae"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.cae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "cae", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    VAT Number\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.registrationNumber),
      expression: "company.registrationNumber"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "registrationNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Registry office\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.registryOffice),
      expression: "company.registryOffice"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.registryOffice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "registryOffice", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Bio\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Company Bio\n                                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.biography),
      expression: "company.biography"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "rows": "4",
      "placeholder": "Write a small biography describing your company."
    },
    domProps: {
      "value": (_vm.company.biography)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "biography", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Contacts\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-8 py-0 mb-2",
    class: {
      error: _vm.$v.company.reservationEmail.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', [_vm._v("Email - Reservations")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.reservationEmail),
      expression: "company.reservationEmail"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.company.reservationEmail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "reservationEmail", $event.target.value)
      }, _vm.$v.company.reservationEmail.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.reservationEmail.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.reservationEmail.isEmailValid) ? _c('span', [_vm._v("Invalid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Phone - Reservations\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.reservationPhone),
      expression: "company.reservationPhone"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.reservationPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "reservationPhone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-8 py-0 mb-2",
    class: {
      error: _vm.$v.company.financialEmail.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', [_vm._v("Email - Financial")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.financialEmail),
      expression: "company.financialEmail"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.company.financialEmail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "financialEmail", $event.target.value)
      }, _vm.$v.company.financialEmail.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.financialEmail.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.financialEmail.isEmailValid) ? _c('span', [_vm._v("Invalid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Calendar\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Start Hour\n                        ")]), _vm._v(" "), _c('timepicker', {
    attrs: {
      "format": "hh:mm",
      "showOnTop": true,
      "availableHours": _vm.possibleCalendarHours,
      "defaultTime": _vm.defaultCalendarStartHour
    },
    on: {
      "change": _vm.setCalendarStartTime
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: " border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                Advanced Details\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0 mb-2"
  }, [_vm._m(1), _vm._v(" "), _c('v-select', {
    staticClass: "bg-lighter",
    attrs: {
      "label": "description",
      "options": _vm.describeOffer,
      "onChange": _vm.setOfferType
    },
    model: {
      value: (_vm.selectedDescribeOffer),
      callback: function($$v) {
        _vm.selectedDescribeOffer = $$v
      },
      expression: "selectedDescribeOffer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0 mb-2",
    class: {
      error: _vm.$v.company.tagline.$invalid
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Tagline\n                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                        *\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tagline),
      expression: "company.tagline"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.tagline)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "tagline", $event.target.value)
      }, _vm.$v.company.tagline.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.company.tagline.$invalid) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.company.tagline.required) ? _c('span', [_vm._v("Tagline is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.company.tagline.minLength) ? _c('span', [_vm._v("Must have at least 4 characters")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2 text-right"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": _vm.$v.company.$invalid
    },
    on: {
      "click": _vm.save
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                    Country\n                                    "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                                        *\n                                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_c('span', {
    staticClass: "fs-small"
  }, [_vm._v("Choose the best option to describe your offer.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-61accfaa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61accfaa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabCompany.vue
// module id = 1546
// module chunks = 0